import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "show-pages",
  templateUrl: "./show-pages.component.html",
  styleUrls: ["./show-pages.component.scss"]
})
export class ShowPagesComponent {
  @Input() page: number;
  @Input() count: number;
  @Input() perPage: number;

  constructor() {}

  getMin(): number {
    return this.perPage * this.page - this.perPage + 1;
  }

  getMax(): number {
    let max = this.perPage * this.page;
    if (max > this.count) {
      max = this.count;
    }
    return max;
  }

  totalPages(): number {
    return Math.ceil(this.count / this.perPage) || 0;
  }
}
